import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/embr/assets/images/embr32.png'


_pushScopeId("data-v-665ddfa2")
const _hoisted_1 = { class: "mr-2 text-base bal-btn-2" }
const _hoisted_2 = {
  key: 2,
  class: "hidden lg:block"
}
const _hoisted_3 = { class: "w-80 sm:w-96" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "text-lg mb-3 px-3 pt-3" }, " MondrianSwap ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block" }, " Add MOND to Wallet ", -1)
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-2 px-2 mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2 text-left" }, " TVL ", -1)
const _hoisted_9 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2 text-left" }, " MOND Price ", -1)
const _hoisted_11 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-2 px-2 mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2 text-left" }, " Market Cap ", -1)
const _hoisted_14 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2 text-left" }, " Circulating Supply ", -1)
const _hoisted_16 = { class: "text-xl font-medium truncate flex items-center" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingIcon = _resolveComponent("BalLoadingIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, { "no-pad": "" }, {
    activator: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.upToLargeBreakpoint ? !_ctx.loading : true)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_0,
              width: "28",
              class: _normalizeClass({ 'mr-2': !_ctx.upToLargeBreakpoint })
            }, null, 2))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_BalLoadingIcon, {
              key: 1,
              size: "sm"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.fNum(_ctx.embrPrice, 'usd')), 1))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.statusV1 == 0)
            ? (_openBlock(), _createBlock(_component_BalBtn, {
                key: 0,
                color: "transparent",
                flat: "",
                class: "mr-2 text-base",
                size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
                circle: _ctx.upToLargeBreakpoint,
                onClick: _ctx.addTokenToMetaMask
              }, {
                default: _withCtx(() => [
                  (_ctx.upToLargeBreakpoint ? !_ctx.loading : true)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_0,
                        width: "28",
                        class: _normalizeClass({ 'mr-2': !_ctx.upToLargeBreakpoint })
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["size", "circle", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.statusV1 == 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "bal-btn migrate",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.approveV1 && _ctx.approveV1(...args)))
              }, "Approve V2"))
            : _createCommentVNode("", true),
          (_ctx.statusV1 == 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "bal-btn migrate",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.migrateV1 && _ctx.migrateV1(...args)))
              }, "Migrate V2"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.fNum(_ctx.tvl, 'usd_lg')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.fNum(_ctx.embrPrice, 'token_fixed')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, "$" + _toDisplayString(_ctx.fNum(_ctx.marketCap, 'usd_lg')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.fNum(_ctx.circulatingSupply, 'token_lg')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}